// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xIYLw","badges":"styles_badges__2A-25"};